module.exports = __webpack_public_path__ + "static/ppt-masterclass-logo-white.ebc80fbd.png";